import React from 'react'
import {icons} from '../img/Icons';
import SvgIcon from './SvgIcon';
import styled from 'styled-components';

function PDLineBreak(props) {
    const {pdLogo} = icons;
    const PDLineBreak = styled.div`
        width: 100%;
        height: max-content;
        display: flex;
        justify-content: center;
        align-items: center;
        .line {
            width: 40%;
            height: 1px;
            background: ${props.colour};
        }
        svg {
            margin: 5px;
        }
    `;
    return(
        <PDLineBreak>
                <div className="line"></div>
                <SvgIcon width="15px" fill={props.colour} icon={pdLogo}/>
                <div className="line"></div>
        </PDLineBreak>
    )
}

export default PDLineBreak;